export default __webpack_public_path__ + "static/media/vf-logo.8a4d4d08.svg";